// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Options2Line from "@store/Library/Components/Toolkit/Icons/Options2/Options2Line";
import { filtersProps } from "@store/Themes/common/props/filters";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    showIcon = "showIcon",
}

const mobileHiddenStyles = () => css`
    ${breakpoint("sm", "down")} {
        display: none;
    }
`;

export interface ProductListFilterTitleProps extends WidgetProps {
    fields: {
        [fields.showIcon]: boolean;
    };
}

export interface ProductListFilterTitleStyles {
    filterText?: TypographyPresentationProps;
    filterTextIcon?: IconPresentationProps;
}

export const productListFilterTitleStyles: ProductListFilterTitleStyles = {
    filterText: {
        forwardAs: "h2",
        css: css`
            ${mobileHiddenStyles()}
            ${spacingStyles(null, filtersProps.spacing)}
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: ${filtersProps.borderCss};
            padding-bottom: ${pxToRem(14)};

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.base};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.small};
            `}
        `,
    },
    filterTextIcon: {
        src: Options2Line,
        css: css`
            margin-left: ${pxToRem(8)};
        `,
        color: "primary.light",
    },
};

const styles = productListFilterTitleStyles;

const ProductListFilterTitle: FC<ProductListFilterTitleProps> = ({ fields }) => {
    return (
        <Typography {...styles.filterText} data-test-selector="productListFilterList">
            {translate("Filters")}
            {fields.showIcon && <Icon {...styles.filterTextIcon} />}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFilterTitle,
    definition: {
        group: "Product List",
        displayName: "Filter Title",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
